import type { ScreenSchema } from './types';

const orderingQuestionSchema: ScreenSchema = {
  template: 'ordering-question',
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' },
        { field: 'question' }
      ]
    },
    feedback: { parts: [{ field: 'feedback' }] },
    'feedback-correct': { parts: [{ field: 'feedback.correct' }] },
    'feedback-incorrect': { parts: [{ field: 'feedback.incorrect' }] }
    // Numeric position feedback (feedback.1, feedback.2 …) cannot be statically
    // defined as slots. S3 audio still resolves via key derivation (screen.id-feedback-N).
    // JiT narration text for numeric variants is a Phase 9 gap.
  }
};

export default orderingQuestionSchema;
